import apiFetch from '@scale/frontend-lib/api-fetch';
import type { EmbeddedContentDto, UpsertEmbeddedContentPayload } from '@scale/sensor-fusion-shared';

export const getEmbeddedContentOnProject = async (
  projectId: string,
): Promise<EmbeddedContentDto> => {
  return apiFetch(null, `internal/embedded-content/project/${projectId}`);
};

export const upsertEmbeddedContentOnProject = async (
  projectId: string,
  payload: UpsertEmbeddedContentPayload,
): Promise<EmbeddedContentDto> => {
  return apiFetch(null, `internal/embedded-content/project/${projectId}`, {
    method: 'PUT',
    body: payload,
  });
};
